import {
  ECOSYSTEM_CLASSIFICATION_FACTS_BY_LEVEL,
  EcosystemClassificationType,
} from '@/api/rest/resources/types/ecosystemClassification';
import { LABEL_FILTERS, PlotReportFactLabelNameEnum } from '@/api/rest/resources/types/fact';
import { useOrganizationIndicatorReportingFact } from '@/pages/shared/hooks/useOrganizationFact';
import { getFactsFromFactArray } from '@/pages/shared/hooks/utils';
import { isNullish } from '@/utils/booleans';

export const useGetEcosystemClassificationFacts = (
  category: EcosystemClassificationType,
  plotGroupId?: string | null,
) => {
  const factNames = ECOSYSTEM_CLASSIFICATION_FACTS_BY_LEVEL[`${category}`];

  const facts = useOrganizationIndicatorReportingFact(
    Object.values(factNames).filter((f) => !isNullish(f)) as string[],
    undefined,
    {
      [PlotReportFactLabelNameEnum.class_name]: LABEL_FILTERS.ALL,
    },
    plotGroupId,
    true,
  );

  const firstScalarFacts =
    getFactsFromFactArray<number>(facts, factNames.firstScalarFact)?.filter((fact) => !isNullish(fact.value)) ?? [];
  const secondScalarFacts = factNames.secondScalarFact
    ? (getFactsFromFactArray<number>(facts, factNames.secondScalarFact)?.filter((fact) => !isNullish(fact.value)) ?? [])
    : [];
  const graphFacts =
    getFactsFromFactArray<number>(facts, factNames.graphFact)?.filter((fact) => !isNullish(fact.value)) ?? [];

  return {
    firstScalarFacts,
    secondScalarFacts,
    graphFacts,
  };
};
